import { createAction } from 'redux-actions';
import { HYDRATE } from 'next-redux-wrapper';

export const hydrate = createAction(HYDRATE);
